import React from 'react';
import { styled } from '@mui/material';
import Paper from '@mui/material/Paper';
import { UserRole } from 'business/definitions';
import SubRoleSwitch from './ui/SubRoleSwitch';
import { RoleTree } from './types';

const StyPaper = styled(Paper)(({ theme }) => ({
    flexDirection: 'column',
    display: 'flex',
    padding: theme.spacing(1),
}));

type Props = {
    addRole: (r: UserRole) => void;
    removeRole: (r: UserRole) => void;
    userRoles: UserRole[];
    roleTree: RoleTree;
};

/**
 * A component in charge of displaying the logic for setting one simple user subrole with no permissions (like "Accès au requêteur")
 */
const SimpleSubRoleCard = (props: Props): JSX.Element => {
    const { userRoles, roleTree, addRole, removeRole } = props;

    const isRoleSelected = () => userRoles.includes(roleTree.roleName);

    const handleChangeRole = (event: React.ChangeEvent<HTMLInputElement>) =>
        event.target.checked
            ? addRole(roleTree.roleName)
            : removeRole(roleTree.roleName);

    return (
        <StyPaper>
            <SubRoleSwitch
                roleTree={roleTree}
                isSwitchSelected={isRoleSelected}
                handleSwitchEvent={handleChangeRole}
            />
        </StyPaper>
    );
};

export default SimpleSubRoleCard;
